import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Image,
  Input,
  Select,
  Spin,
  Tag,
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { authenticateToken } from "../../utils/auth";
import { getImgUrl, getParamValue, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { useLocation } from "react-router";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import {
  BarcodeOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const GiftProductList = ({
  selectedProducts,
  setSelectedProducts,
}): ReactElement => {
  const [limit, setLimit] = useState(16);
  const [type, setType] = useState("JC_MART");
  const [productData, setProductData] = useState<any>({
    loading: false,
    item: [],
  });
  const [status, setStatus] = useState("");
  const [key, setKey] = useState("");
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryId, setCategoryId] = useState<any>();
  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [brandId, setBrandId] = useState<any>();
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopId, setShopId] = useState<any>();

  const ref = useRef(null);

  const router = useLocation();
  const page = getParamValue(router?.search, "page");

  const [form] = Form.useForm();

  const reseAllFieldData = () => {
    setKey("");
    setType("");
    setShopId("");
    setCategoryId("");
    setBrandId("");
    form.resetFields();
  };

  const fetchProducts = useCallback(() => {
    try {
      setProductData({ loading: true, item: [] });
      const url =
        `${process.env.REACT_APP_CATALOG_READER_API}/global-product?` +
        `page=${page || 0}` +
        `&limit=${limit || 16}` +
        (status ? `&status=${status}` : ``) +
        (key ? `&key=${key}` : ``) +
        (categoryId ? `&categoryId=${categoryId}` : ``) +
        (brandId ? `&brandId=${brandId}` : ``) +
        (type ? `&type=${type}` : ``);

      fetch(url, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProductData({ loading: false, item: data });
        })
        .catch(() => {
          setProductData({ loading: true, item: [] });
        });
    } catch (error) {
      setProductData({ loading: true, item: [] });
      console.log(error, "error");
    }
  }, [limit, page, status, categoryId, brandId, shopId, key, type]);

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      if (val) {
        setProductOptions({ loading: true, list: [] });
        const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

        const res = await axios.get(
          `${encodedUri}/admin/product/search?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setProductOptions({
          loading: false,
          list: res?.data?.keys?.map((product: { name: any }) => {
            return {
              value: product?.name,
              label: product?.name,
            };
          }),
        });
      }
    },
    [status, type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/category/search?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoriesOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            id: category?.id,
            title: category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  // const getShopsOptions = useCallback(
  //   async (val?: string) => {
  //     setShopsOptions({ loading: true, list: [] });

  //     const res = await axios.get(
  //       `${process.env.REACT_APP_CATALOG_READER_API}/shop/admin/search?page=0&limit=20` +
  //         (type ? `&type=${type}` : ``) +
  //         (val ? `&key=${val}` : ``) +
  //         (orderShopId ? `&shopId=${orderShopId}` : ``),
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authenticateToken()}`,
  //         },
  //       }
  //     );
  //     setShopsOptions({
  //       loading: false,
  //       list: res?.data?.shops?.map((shop) => {
  //         return {
  //           id: shop?.id,
  //           name: shop?.name,
  //         };
  //       }),
  //     });
  //   },
  //   [type]
  // );

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    if (type) {
      getCategoriesOptions();
      getBrandsOptions();
    }
  }, [type]);

  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "product") getProductOptions(value);
          else if (field === "category") getCategoriesOptions(value);
          else if (field === "brand") getBrandsOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getBrandsOptions, getCategoriesOptions, getProductOptions, type]);

  // const debouncedSearch = useCallback(
  //   debounce((val, type) => {
  //     // getProductOptions(val);
  //    if (type === 'product') getProductOptions(val);
  //    else if (type === 'category') getCategoriesOptions(val);
  //    else if (type === 'brand') getBrandsOptions(val);
  //    else if (type === 'shop') getShopsOptions(val);
  //   }, 800),
  //   []
  // )

  // const handleSearch = (val: string, type) => {
  //   debouncedSearch(val, type);
  // };

  useEffect(() => {
    setShopId("");
    setShopsOptions({ list: [], loading: false });
    setBrandId("");
    setBrandsOptions({ list: [], loading: false });
    setCategoryId("");
    setCategoriesOptions({ list: [], loading: false });
    form.resetFields([
      "product_search",
      "category_search",
      "brand_search",
      "shop_search",
    ]);
  }, [type]);

  return (
    <div className="product-lists">
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="type_search" initialValue={type}>
            <Select
              showSearch
              placeholder="Filter by Type"
              onChange={(val) => setType(val as string)}
            >
              <Select.Option value="">ALL TYPES</Select.Option>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="product_search" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "product")}
              onSelect={(val) => setKey(val.toString())}
              options={productOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                productOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                }}
                enterButton
                loading={productOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item name="category_search">
            <Select
              showSearch
              placeholder="Filter by Category"
              optionFilterProp="children"
              onChange={(val) => setCategoryId(val)}
              onSearch={(e) => handleSearch(e, "category")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoriesOptions.list.map((category, i) => (
                <Option value={category.id} key={i}>
                  {category.title}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="brand_search">
            <Select
              showSearch
              placeholder="Filter by Brand"
              optionFilterProp="children"
              onChange={(val) => setBrandId(val)}
              onSearch={(e) => handleSearch(e, "brand")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {brandsOptions.list.length ? (
                <Option value={""}>All Brands</Option>
              ) : undefined}{" "}
              {brandsOptions.list.map((brand, i) => (
                <Option value={brand.id} key={i}>
                  {brand.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" size="large" danger onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {selectedProducts?.map((product) => (
                <Tag
                  color="orange"
                  className="mb-2"
                  closable
                  key={product?.id}
                  onClose={async () => {
                    await setSelectedProducts((prevProducts: any) => {
                      const arr = Array.from(prevProducts);
                      const newArr = arr.filter(
                        (item: any) => item?.id !== product?.id
                      );
                      return newArr;
                    });
                  }}
                >
                  {product?.name}
                </Tag>
              ))}
            </div>
          </div>

          <div className="row">
            {productData.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {productData.item?.products?.length ? (
                    productData?.item?.products?.map(
                      (product: any, index: number) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product major">
                              <Avatar
                                shape="square"
                                size={50}
                                src={
                                  <Image
                                    src={getImgUrl(product?.productImage)}
                                    height={50}
                                  />
                                }
                                className="mr-3"
                              />
                              <span className="name">{product?.name}</span>
                            </div>
                            <div className="single-product major">
                              <div className="">
                                {product?.variations?.length
                                  ? product?.variations?.map(
                                      (variant, index) => (
                                        <React.Fragment key={index}>
                                          <div className="d-flex _text-center mb-1">
                                            {variant?.barCode ? (
                                              <Tag className="d-flex align-items-center">
                                                <BarcodeOutlined className="mr-1" />{" "}
                                                {variant?.barCode}
                                              </Tag>
                                            ) : product?.barCode ? (
                                              <Tag className="d-flex align-items-center">
                                                <BarcodeOutlined className="mr-1" />{" "}
                                                {product?.barCode}
                                              </Tag>
                                            ) : undefined}
                                            <Tag
                                              color={
                                                variant?.stock < 10
                                                  ? `red`
                                                  : `green`
                                              }
                                            >
                                              {variant?.variationName?.toUpperCase()}{" "}
                                              : {variant?.stock || 0}
                                            </Tag>
                                            <Tag>
                                              MRP{" "}
                                              {variant?.price?.currencyCode ||
                                                "Tk"}
                                              {variant?.price
                                                ?.discountedPrice ||
                                                variant?.price?.mrp}
                                              {variant?.price
                                                ?.discountedPrice &&
                                                variant?.price
                                                  ?.discountedPrice !==
                                                  variant?.price?.mrp && (
                                                  <span className="text-danger">
                                                    {" "}
                                                    <del>
                                                      {variant?.price
                                                        ?.currencyCode || "Tk"}
                                                      {variant?.price?.mrp}
                                                    </del>
                                                  </span>
                                                )}
                                            </Tag>
                                          </div>
                                        </React.Fragment>
                                      )
                                    )
                                  : undefined}
                              </div>
                            </div>

                            <div className="single-product">
                              <span
                                className={`radius-btn ${
                                  product?.deleted === false
                                    ? "active-btn"
                                    : "deleted-btn"
                                }`}
                              >
                                {product?.deleted === false
                                  ? "Active"
                                  : "Deleted"}
                              </span>
                            </div>

                            <div className="single-product">
                              <Button
                                type="primary"
                                className="mx-1"
                                onClick={async () => {
                                  await setSelectedProducts(
                                    (prevProducts: any) => {
                                      let arr = Array.from(prevProducts);
                                      arr?.find(
                                        (item: any) => item?.id === product?.id
                                      )
                                        ? (arr = arr.filter(
                                            (item: any) =>
                                              item?.id !== product?.id
                                          ))
                                        : arr.push(product);
                                      return arr;
                                    }
                                  );
                                }}
                                disabled={
                                  product?.deleted ||
                                  !product?.variations?.[0]?.stock
                                }
                                danger
                              >
                                {selectedProducts?.find(
                                  (item) => item?.id === product?.id
                                ) ? (
                                  <MinusOutlined />
                                ) : (
                                  <PlusOutlined />
                                )}
                              </Button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Products" />
                  )}
                </div>
              </div>
            )}
          </div>
          <PaginationTwo
            {...productData.item}
            limit={limit}
            page={productData?.item?.currentPageNumber || 0}
          />
        </div>
      </div>
    </div>
  );
};

export default GiftProductList;
